
<template>
<Loader v-if="loader" />
    <div class="grid">
      <div class="col-12"><p>Clicca sulla barra di tuo interesse per vedere la tabella dettagli</p></div>
        <div class="col-12 lg:col-6">
            <div class="card">
                <h2>Pods</h2>
                <small>Numero pod in fornitura</small>
                <Chart ref="chartRefPods" type="bar" :data="podsData" @select="getDatailsTable($event, podsData)" />
                <i class="pi pi-download" @click="exportChart($refs.chartRefPods)"></i>
            </div>
        </div>
        <div class="col-12 lg:col-6">
            <div class="card">
                <h2>Consumi</h2>
                <small>Euro</small>
                <Chart ref="chartRefConsumption" type="bar" :data="consumptionData" @select="getDatailsTable($event, consumptionData)" />
                <i class="pi pi-download" @click="exportChart($refs.chartRefConsumption)"></i>
            </div>
        </div>
    </div>

    <div id="details-anchor"></div>

    <div class="card" id="details" v-if="details.length">
        <h2>Dettagli</h2>
        <h6>{{subTitle}}</h6>
        <DataTable  :value="details" :paginator="true" :rows="10" :filters="filters" 
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
            currentPageReportTemplate="{first} a {last} di {totalRecords}">
            <template #header>
                        <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                            </span>
                        </div>
            </template>
            <template #empty>
                <div class="text-center">Nessun dato trovato.</div>
            </template>
            <Column field="pod_name" header="Pod" :sortable="true"></Column>
            <Column field="cliente" header="Cliente" :sortable="true"></Column>    
            <Column field="qf_importo" header="Q.Fissa (euro)" :sortable="true"></Column>
            <Column field="qp_importo" header="Q.Potenza (euro)" :sortable="true"></Column>
            <Column field="qv_importo" header="Q.Variabile (euro)" :sortable="true"></Column>
            <Column field="tot_importo" header="Totale Importi (euro)" :sortable="true"></Column>
            <Column header="Stima" :sortable="true">
                <template #body="slotProps">
                   {{slotProps.data.stima == 0 ? 'No' : 'Si'}}
                </template>
            </Column>
            <Column field="periodo_rif" header="Mese" :sortable="true"></Column>
        </DataTable>
    </div>
</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { getCurrentInstance, onMounted, ref, computed } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
     setup() {
        
        const loader = ref(false);
        const chartRefPods = ref(null);
        const chartRefConsumption = ref(null);
        const details = ref([]);
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const podsData = ref({
            labels: [],
            labelsDate: [],
            datasets: [
                {
                    label: 'Reali',
                    backgroundColor: '#ff6775',
                    data: []
                },
                {
                    label: 'Stime',
                    backgroundColor: '#c9c9c9',
                    data: []
                },            
            ]
        });
        const consumptionData = ref({
            labels: [],
            labelsDate: [],
            datasets: [
                {
                    label: 'Reali',
                    backgroundColor: '#ff6775',
                    data: []
                },
                {
                    label: 'Stime',
                    backgroundColor: '#c9c9c9',
                    data: []
                },            
            ]
        });
  
        onMounted(() => {       
            getData();           
        })

        const getData = async () => {
            loader.value = true;
            const response = await service.getPreviews().then((res) => {
                return res          
            }).finally(()=>{
              loader.value = false;
            })
            const data = await response;

            /// inizio grafico 1
            if(chartRefPods.value){
                
                let  numPodReali = [];
                let  numPodStimati = [];
                for (const [key, value] of Object.entries(data.items)) {
                    
                    podsData.value.labelsDate.push(key)
                    podsData.value.labels.push(moment(key).locale('it').format('MMMM YYYY').toUpperCase())
                    numPodReali.push(value[0].numPodReali)
                    numPodStimati.push(value[0].numPodStimati)
                }
                podsData.value.datasets[0].data = numPodReali
                podsData.value.datasets[1].data = numPodStimati

                chartRefPods.value.refresh();          
            }
            
            /// inizio grafico 2
            if(chartRefConsumption.value){
                
                let  euroReali = [];
                let  euroStime = [];          
                for (const [key, value] of Object.entries(data.items)) {
                    
                    consumptionData.value.labelsDate.push(key)
                    consumptionData.value.labels.push(moment(key).locale('it').format('MMMM YYYY').toUpperCase())
                    euroReali.push(value[0].euroPodReali)
                    euroStime.push(value[0].euroPodStimati)
                    
                }
                consumptionData.value.datasets[0].data = euroReali
                consumptionData.value.datasets[1].data = euroStime
            
                chartRefConsumption.value.refresh();
            }
        };

        const getDatailsTable = (evt, refData) => {
            let index = evt.element.index
            let stima = evt.element.datasetIndex
            let date = refData.labelsDate[index]
            details.value = []
            loader.value = true;
            service.getPreviewDetails(date, stima).then((res) => {
                details.value = res.items      
            }).finally(() => {
                document.getElementById("details-anchor").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                loader.value = false;
            })
        }

        const subTitle = computed(() => {
                let date = moment(details.value[0].periodo_rif).locale('it').format('MMMM YYYY').toUpperCase()       
                let isEstimation = details.value[0].stima == 0 ? 'REALI' : 'STIME'    
                 return `${date} - ${isEstimation}`
        })

        const exportChart = (refGraph) => {
            let imgGraph = refGraph.getBase64Image()       
            let a = document.createElement('a')   
            a.href = imgGraph
            a.download = 'chart-export.png'
            a.click()
            a = null
        }

        return {podsData, consumptionData, getData, chartRefPods, chartRefConsumption, exportChart, getDatailsTable, details,
                filters, loader,  subTitle
        }
    }
}
</script>
<style scoped>
.pi-download {
    cursor: pointer;
}

#details-anchor {
    margin-bottom: 60px;
}
</style>
